const styles = (theme) => ({
  paper: {
    gap: 0,
    padding: 1,
    borderRadius: 2,
    display: "flex",
    overflow: "hidden",
    flexDirection: "column",
    backgroundColor:
      theme.palette.mode == "dark"
        ? theme.palette.secondary.dark
        : theme.palette.secondary.lighter,
  },
  box: { display: "flex", flexDirection: "row", gap: 0.5 },
});

export default styles;
